export function componentToHex(c: any) {
    let hex = Number(c).toString(16);
    if (hex.length < 2) {
        hex = "0" + hex;
    }
    return hex;

}

export function rgbToHex(r: number, g: number, b: number) {
    return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}